define('Application',['require','backbone','marionette','module/MenuModule','module/CartModule','module/ReviewModule','module/AboutModule','module/AdaCompliantModule','module/GdprReportModule','controller/IndexController','controller/ErrorController','controller/BookingController','controller/ReviewController','controller/GdprReportController','controller/OnlineMeetingController','controller/MedicalTestController','view/layout/MainLayout','plugin/PluginsInitializer','Config','lib/theme/ColorSchemeHandler','lib/theme/ThemeSettings','lib/plugin/PluginBroker','model/ClientModel','lib/AppRouter','lib/Navigation','lib/ImageFallback','bowser','lib/view/StatusAnnouncer'],function (require) {

	var Backbone = require('backbone');
	var Marionette = require('marionette');
	var MenuModule = require('module/MenuModule');
	var CartModule = require('module/CartModule');
    var ReviewModule = require('module/ReviewModule');
    var AboutModule = require('module/AboutModule');
    //var BookingResultPopupModule = require('module/BookingResultPopupModule');
    var AdaCompliantModule = require('module/AdaCompliantModule');
    var GdprReportModule = require('module/GdprReportModule');
	var IndexController = require('controller/IndexController');
    var ErrorController = require('controller/ErrorController');
	var BookingController = require('controller/BookingController');
	var ReviewController = require('controller/ReviewController');
	var GdprReportController = require('controller/GdprReportController');
	var OnlineMeetingController = require('controller/OnlineMeetingController');
	var MedicalTestController = require('controller/MedicalTestController');
	var MainLayout = require('view/layout/MainLayout');
	var PluginsInitializer = require('plugin/PluginsInitializer');
	var Config = require('Config');
    var ColorSchemeHandler = require('lib/theme/ColorSchemeHandler');
	var ThemeSettings = require('lib/theme/ThemeSettings');
	var PluginBroker = require('lib/plugin/PluginBroker');
    var ClientModel = require('model/ClientModel');
	var AppRouter = require('lib/AppRouter');
	var Navigation = require('lib/Navigation');
	// Self-registering: swaps in <img data-fallback-src> images, replacing the themes'
	// old inline onerror handlers, which CSP blocks under csp_strict_inline.
	require('lib/ImageFallback');
	var Bowser = require('bowser');
	var StatusAnnouncer = require('lib/view/StatusAnnouncer');

	return Marionette.Application.extend({
	
		_layout: null,
		_modules: {
			menu: null,
			review: null
		},
        _colorScheme: null,
		_extPlugin: null,
        _clientModel: null,
		
	    initialize: function() {
			this._csrfProtection();

	        this.addRegions({
	            root: '#sb_main'
	        });

	        this._secureHeadersSetup();

	        this._extPlugin = this.getOption('extPlugin');
	    },
	
	    onStart: function() {
			var _this = this;
	    	var themeSettings = ThemeSettings.getInstance(
				this.getOption('themeVars'), this.getOption('theme'),
				this.getOption('userThemeSettings')
			);

	        this._colorScheme = new ColorSchemeHandler({
				'theme': this.getOption('theme'),
				'themeSettings': themeSettings
			});

	        this.initErrorRouter();

	        // @todo !!!MUST BE FIXED
			this.initClientModel();

			var pluginsInitializer = new PluginsInitializer({
				plugins: this._getActivePlugins(),
				app: this,
				clientModel: this._clientModel
			});

			this.listenTo(PluginBroker.getInstance(), 'perform:event', function (event, arguments){
				_this._performModuleEvent(event, arguments);
			});

			pluginsInitializer.initPlugins();

	    	this.initLayout();
			this.initRoutes();

            Backbone.Wreqr.radio.channel('page').vent.on(
                'shown', _.bind(this._initPluginModules, this)
            );

            this.initExtPlugins();

			this._initReceiveMessages();
			this._sendApplicationReady();
			this._updateWidgetSize();
			this._sendStepChanged();
			this._announceStepChanges();
			this._initCalendarTranslations();
			this._detectBrowser();

			this._handleAjaxErrors();
			if (Config.getInstance().getOption('widget_type')) {
				// fix for ios
				// start with delay for widget as it can be already started by widget notification
				// just because notification after iframe reload is not come instantly.
				setTimeout(function () {
					if (!Backbone.History.started) {
						Navigation.start();
					}
				}, 100);
			} else {
				Navigation.start();
			}
	    },

		_detectBrowser: function () {
			var browser = Bowser.getParser(window.navigator.userAgent);
			$('body').addClass([
				'browser-' + browser.getBrowserName().toLowerCase().replace(/ /g,"_"),
				'platform-' + browser.getPlatformType().toLowerCase().replace(/ /g,"_"),
				'os-' + browser.getOSName().toLowerCase().replace(/ /g,"_"),
			].join(' '))
		},

		_initCalendarTranslations: function () {
			jQuery.fn.datepicker.dates['__'] = {
				days: [Locale.get('Sunday'), Locale.get('Monday'), Locale.get('Tuesday'), Locale.get('Wednesday'), Locale.get('Thursday'), Locale.get('Friday'), Locale.get('Saturday'), Locale.get('Sunday')],
				daysShort: [Locale.get('Sun'), Locale.get('Mon'), Locale.get('Tue'), Locale.get('Wed'), Locale.get('Thu'), Locale.get('Fri'), Locale.get('Sat'), Locale.get('Sun')],
				daysMin: [Locale.get('Su'), Locale.get('Mo'), Locale.get('Tu'), Locale.get('We'), Locale.get('Th'), Locale.get('Fr'), Locale.get('Sa'), Locale.get('Su')],
				months: [
					Locale.get('_January_'), Locale.get('_February_'), Locale.get('_March_'), Locale.get('_April_'),
					Locale.get('_May_'), Locale.get('_June_'), Locale.get('_July_'), Locale.get('_August_'),
					Locale.get('_September_'), Locale.get('_October_'), Locale.get('_November_'), Locale.get('_December_')
				],
				monthsShort: [
					Locale.get('Jan'), Locale.get('Feb'), Locale.get('Mar'), Locale.get('Apr'),
					Locale.get('May'), Locale.get('Jun'), Locale.get('Jul'), Locale.get('Aug'),
					Locale.get('Sep'), Locale.get('Oct'), Locale.get('Nov'), Locale.get('Dec'),
				],
				today: Locale.get('Today'),
				suffix: [],
				meridiem: []
			};
			jQuery.fn.datepicker.defaults.language = '__';
		},

		_sendStepChanged : function () {
            var messagesChannel = Backbone.Wreqr.radio.channel('booking');
            var instance = this;
            messagesChannel.vent.on('step:changed', function (data) {
            	var position = instance.getLayout().content.$el.offset();

                if (window.parent && window.parent !== window) {
                    window.parent.postMessage({
                        'event': 'stepChanged',
						'step': data.step,
						'content_position': position.top
                    }, '*');
                }
            });
        },

		/**
		 * Writes a translated status message for the newly-shown booking step into the
		 * screen-reader live region, so step navigation is announced audibly (WCAG 4.1.3).
		 */
		_announceStepChanges: function () {
			var STEP_ANNOUNCE_KEYS = {
				'location': 'step_announce_location',
				'category': 'step_announce_category',
				'service': 'step_announce_service',
				'provider': 'step_announce_provider',
				'datetime': 'step_announce_datetime',
				'details': 'step_announce_details'
			};

			Backbone.Wreqr.radio.channel('booking').vent.on('step:changed', function (data) {
				var translationKey = STEP_ANNOUNCE_KEYS[data.step];
				if (!translationKey) {
					return;
				}

				StatusAnnouncer.announce(Locale.get(translationKey));
			});
		},

        _secureHeadersSetup: function () {
			var config = Config.getInstance();
			if (config.getOption('_session_id')) {
                jQuery.ajaxSetup({headers: {
					'X-Session-Id': config.getOption('_session_id')
				}});
			}
		},

        /**
		 * should be called first
         */
		initErrorRouter : function(){
            var errorRouter = new AppRouter({
                // NB the first declared route wins inside a router, so the catch-all goes last
                appRoutes: {
                    'error/e403(/:message)(/)': 'e403',
                    'error/e404(/:message)(/)': 'e404',
                    'error/e500(/:message)(/)': 'e500',
                    '*notFound': 'e404'
                },
                controller: new ErrorController({
                    'root': this.getRootRegion(),
                    'app': this
                })
            });
		},

		_checkClientSession : function(){
			var predefined = Config.getInstance().getOption('predefined') || {};
			var clearSession = Config.getInstance().getOption('clear_session') || false;

			if((clearSession || (predefined && predefined.client)) && this._clientModel.get('id')){
				var clientData = predefined.client;

				//if predefined data != logged client data => reset client session
				if(clearSession ||
					(String(clientData.email).trim().toLowerCase() !== String(this._clientModel.get('email')).trim().toLowerCase() ||
					String(clientData.name).trim().toLowerCase() !== String(this._clientModel.get('name')).trim().toLowerCase() ||
					String(clientData.phone).replace(/\D/g,'') !== String(this._clientModel.get('phone')).replace(/\D/g,'') )
				){
					this._clientModel.fetch({
						reset: true,
						data: {
							reset_session : 1
						}
					})
				}
			}
		},

        initClientModel: function () {
            //if (!Config.getInstance().getPluginStatus('client_login')) {

				var _this = this;
                this._clientModel = new ClientModel();

				this.listenToOnce(this._clientModel, 'sync', function () {
					_this._checkClientSession();
				});

				this.listenTo(Config.getInstance(), 'config:changed', function(){
					_this._checkClientSession();
				});

				this._clientModel.fetch();
				// we do not need to reset session in such case, otherwise it will logout client right after
				// he book with changed data and will prevent to pay via stripe for example.
				/*this.listenTo(this._clientModel, 'sync', function () {
					_this._checkClientSession();
				});*/
            //} else {
            //    var clientPlugin = PluginBroker.getInstance().getPlugin('client_login');
            //    this._clientModel = clientPlugin.getClientModel();
            //}
		},

        initExtPlugins: function () {
			if (this._extPlugin) {
                this._extPlugin.start();
            }
        },

	    initLayout: function () {
	    	this._layout = new MainLayout();
	    	this.getRootRegion().show(this._layout);

			this.initModules();
	    },
	    
	    initModules: function () {
            this._initMenuModule();
			this._initCartModule();
            this._initReviewModule();
            this._initAboutModule();
            //this._initBookingResultPopupModule();
            this._initGdprReportModule();
			this._initPluginModules();
			this._initAdaModules();
	    },

        _initMenuModule: function () {
            this._modules.menu = new MenuModule({
	    		layout: this.getLayout()
	    	});
        },

		// _initBookingResultPopupModule: function () {
        //     this._modules.booking_result_popup = new BookingResultPopupModule({
        //         layout: this.getLayout()
        //     });
        // },

        _initReviewModule: function () {
            this._modules.review = new ReviewModule({
                layout: this.getLayout()
            });
        },

        _initAboutModule: function () {
            this._modules.about = new AboutModule({
                layout: this.getLayout()
            });
        },

        _initGdprReportModule: function () {
            this._modules.gdpr = new GdprReportModule({
                layout: this.getLayout()
            });
        },

		_initAdaModules: function () {
            this._modules.gdpr = new AdaCompliantModule({
                layout: this.getLayout()
            });
        },

		_initCartModule: function () {
            this.module.cart = new CartModule({
	    		layout: this.getLayout()
	    	});
        },

		_initPluginModules: function () {
            PluginBroker.getInstance().initModules(
                this.getLayout()
            );
		},
		
	    
	    initRoutes: function () {
	    	var controllerParams = {
	    		'root': this.getRootRegion(),
	    		'app': this,
				'clientModel': this._clientModel
	    	};
	    	
	    	var indexRouter = new AppRouter({
	    		appRoutes: {
                    '': 'index',
	    			'show-on-map(/:flag)(/)': 'map',
                    'about(/)': 'about',
	    		},
	    		menuItem: 'index',
	    		controller: new IndexController(controllerParams)
	    	});

			var bookingController = new BookingController(controllerParams);
	    	var bookServiceRouter = new AppRouter({
	    		appRoutes: {
                    'book-service(/location/:location)(/category/:category)(/service/:service)(/count/:count)(/addons/:addons)(/provider/:provider)(/date/:date)(/time/:time)(/wl/:wl)(/r/:r)(/)(:someTrash)': 'bookService',
                    'book-service(/location/:location)(/category/:category)(/service/:service)(/count/:count)(/addons/:addons)(/date/:date)(/time/:time)(/provider/:provider)(/wl/:wl)(/r/:r)(/)(:someTrash)': 'bookServiceClassesProvider',
					'book(/location/:location)(/category/:category)(/service/:service)(/count/:count)(/addons/:addons)(/provider/:provider)(/date/:date)(/time/:time)(/wl/:wl)(/r/:r)(/)(:someTrash)': 'bookService',
                    'book(/location/:location)(/category/:category)(/service/:service)(/count/:count)(/addons/:addons)(/date/:date)(/time/:time)(/provider/:provider)(/wl/:wl)(/r/:r)(/)(:someTrash)': 'bookServiceClassesProvider'
	    		},
	    		menuItem: 'book-service',
	    		controller: bookingController
	    	});
            var bookClassRouter = new AppRouter({
                appRoutes: {
                    'book-class(/location/:location)(/category/:category)(/service/:service)(/count/:count)(/addons/:addons)(/provider/:provider)(/date/:date)(/time/:time)(/wl/:wl)(/r/:r)(/)': 'bookClass',
                    'book-class(/location/:location)(/category/:category)(/service/:service)(/count/:count)(/addons/:addons)(/date/:date)(/time/:time)(/provider/:provider)(/wl/:wl)(/r/:r)(/)': 'bookClassClassesProvider'
                },
                menuItem: 'book-class',
                controller: bookingController
            });

			var clientWaitingListRouter = new AppRouter({
				appRoutes: {
					'client/bookings(/type/:type)(/highlight/:id)(/wl/:wl)(/r/:r)(/)': 'clientBookings',
					'client/bookings(/ids/:ids)(/status/:status)(/wl/:wl)(/r/:r)(/cart_id/:cart_id)(/system/:system)(/)': 'clientBookingsResult',
				},
				menuItem: 'client_waiting_list_bookings',
				controller: bookingController
			});

			var clientBookingsRouter = new AppRouter({
				appRoutes: {
					'client/bookings(/type/:type)(/highlight/:id)(/)': 'clientBookings',
					'client/bookings(/ids/:ids)(/status/:status)(/cart_id/:cart_id)(/system/:system)(/)': 'clientBookingsResult',
					'client/bookings/cancel/:bookingId(/)': 'clientBookingsCancel',
					'client/bookings/reschedule/:bookingId(/date/:date)(/time/:time)(/wl/:wl)(/r/:r)(/)': 'clientBookingsReschedule'
				},
				menuItem: 'client_bookings',
				controller: bookingController
			});


            var reviewsRouter = new AppRouter({
                appRoutes: {
                    'reviews(/page/:page)': 'index'
                },
                menuItem: 'reviews',
                controller: new ReviewController(controllerParams)
            });

            var gdprReportRouter = new AppRouter({
                appRoutes: {
                    'gdpr-report(/)': 'index'
                },
                menuItem: 'gdpr_report',
                controller: new GdprReportController(controllerParams)
            });
            
            var onlineMeetingRouter = new AppRouter({
                appRoutes: {
                    'online-meeting/view/:id(/:hash)(/)': 'onlineMeetingView',
                    'online-meeting/provider/:id(/:hash)(/)': 'onlineMeetingProvider'
                },
                menuItem: 'online_meeting',
                controller: new OnlineMeetingController(controllerParams)
            });
            
            var medicalTestRouter = new AppRouter({
                appRoutes: {
                    'medical-test/check/:id(/:hash)(/)': 'check',
                },
                controller: new MedicalTestController(controllerParams)
            });

            this.initMoreRoutes(controllerParams);
	    },

		initMoreRoutes: function(controllerParams) {

		},

	    getLayout: function () {
	    	return this._layout;
	    },
	    
	    getRootRegion: function () {
	    	return this.root;
	    },
	    
	    _getActivePlugins: function () {
	    	var activePlugins = [];
	    	_.each(Config.getInstance().getOption('plugins'), function (plugin, pluginName) {
	    		if (parseInt(plugin.is_active)) {
	    			activePlugins.push(pluginName);
	    		}
	    	});
	    	
	    	return activePlugins;
	    },

		_performModuleEvent: function (method, args){
			_.each(this._modules, function (module) {
				if (module && _.isFunction(module[method])) {
					module[method].apply(module, args);
				}
			});
		},

		_initReceiveMessages: function () {
			jQuery(window).bind('message', _.bind(this._handleWindowMessage, this));
		},

        _sendApplicationReady: function () {
            if (window.parent && window.parent !== window) {
				window.parent.postMessage({
					'event': 'appReady'
				}, '*');
			}
		},

		_updateWidgetSize: function () {
            if (window.parent && window.parent !== window) {
                window.parent.postMessage({
                    'event': 'updateWidgetSize',
					'height': jQuery('#sb_main').height()
                }, '*');

                _.delay(_.bind(this._updateWidgetSize, this), 100);
            }
		},

		_prepareThemeVars : function(themeVars){
			themeVars = themeVars || {};

			_.each(themeVars, function(value, key){
				if(value && _.isString(key) && key.indexOf('color') !== -1){
					var colors = value.split(',');
					if(colors.length === 3){
						_.each(colors, function(color, index){
							themeVars[key + '_gr' + (index+1)] = color;
						});
					}
				}
			});

			// Because of recent changes to themes, we have to prevent issues for users with old variables widget codes
			if (themeVars.btn_color_1 === undefined) {
				themeVars.btn_color_1 = false;
			}

			return themeVars;
		},

		_handleWindowMessage: function (event) {
			var data = event.originalEvent.data;

			if (_.isObject(data)) {
				if (data.update_theme_vars) {
					var themeVars = this._prepareThemeVars(data.theme_vars);
					ThemeSettings.getInstance().setOptions(themeVars);
					window.themeSettings = themeVars;
					this._colorScheme.parseLess();
				}
                if (data.reviews_vars) {
                    //console.log(data.reviews_vars);
                    Config.getInstance().setOptions(data.reviews_vars);
                }
				if (data.update_config) {
                    Config.getInstance().setOptions(data.config_vars);
					if (!data.rerender) {
						if (!Backbone.History.started) {
							Navigation.start();
						} else {
							Backbone.history.loadUrl(Backbone.history.fragment);
						}
					}
                }

				if(data.hostname){
					Config.getInstance().setOptions({
						'widget_hostname': data.hostname
					});
				}

				if(data.url){
					Config.getInstance().setOptions({
						'widget_url': data.url
					});
				} else if(!Config.getInstance().getOption('widget_url')){
					Config.getInstance().setOptions({
						'widget_url': window.location.href
					});
				}

				if (data.rerender) {
					this.initLayout();
					if (!Backbone.History.started) {
						Navigation.start();
					} else {
						Backbone.history.loadUrl(Backbone.history.fragment);
					}
				}
				if (data.navigate) {
					// any form the parent page may send ('book', '#book', '/book', '/v2/book/'); never leaves the app
					Navigation.go(data.navigate, {
						replace: true,
						routeOnly: true
					});
					Config.getInstance().setOptions({
						last_navigate: data.navigate,
					});
				}
			}
		},

		_csrfProtection: function () {
			var config = Config.getInstance();
			var data = {
				'X-Csrf-Token': config.getOption('csrf_token'),
				'X-Debug': config.getOption('debug_id'),
			};

			if(config.getOption('is_booking_page')){
				data['is-booking-page'] = 1;
			}
			$.ajaxSetup({headers: data});
		},

        _handleAjaxErrors: function () {
            $(document).ajaxError(_.bind(function (event, jqxhr, settings, thrownError) {
            	if (settings.skip_errors) {
					return;
				}
            	if (settings.dataType != 'json') {
					return;
				}
				switch (jqxhr.status) {
					case 403:
                        //this._clientModel.fetch();

                        Backbone.history.navigate('error/e403', {
                            trigger: true
                        });
						break;
					case 404:
                        Backbone.history.navigate('error/e404', {
                            trigger: true
                        });
						break;
					case 500:
                        Backbone.history.navigate('error/e500', {
                            trigger: true
                        });
						break;
				}
			}, this));
		}
	    
	});
	
});
